import React, { Fragment } from "react";
import ClassNames from "classnames";
import { SERVICE_MODES } from "Constants/commonConstants";

import { ReactComponent as RoadIcon } from "Icons/road.svg";
import { ReactComponent as BusIcon } from "Icons/bus.svg";
import { ReactComponent as RailIcon } from "Icons/rail.svg";
import { ReactComponent as AirIcon } from "Icons/air.svg";

import { FlexWrapperT14 } from "Components/Common/Wrapper/FlexWrapper";
import { Spacer } from "Components/Common/Spacer/index";
import { LabelT6 } from "Components/Common/Label/index";

const ServiceModeDetails = (props) => {
  const {
    serviceModeTypesList = [],
    service_mode,
    handleToggleServiceMode,
  } = props;

  const isSelected = (serviceModeEle) => {
    const C1 = service_mode.some((ele) => {
      if (ele.id === serviceModeEle.value) {
        return true;
      } else {
        return false;
      }
    });

    if (C1) {
      return true;
    }

    return false;
  };

  return (
    <Fragment>
      <LabelT6>Service Mode</LabelT6>
      <Spacer spacing={"3px"} />
      <FlexWrapperT14>
        {serviceModeTypesList.map((serviceMode, index) => {
          return (
            <Fragment key={index}>
              {
                <div
                  className={ClassNames(
                    "border-white tCenter wt-100 ml-10 mr-10 pt-10 pb-10 curP",
                    {
                      // 'box-shadow select-icon border-theme br-5': rfqDetails.serviceModes.indexOf(serviceMode.value) > -1
                      "box-shadow select-icon border-theme br-5": isSelected(
                        serviceMode
                      ),
                    }
                  )}
                  key={serviceMode.value}
                  name={serviceMode.value}
                  index={index}
                  onClick={() => {
                    handleToggleServiceMode(serviceMode);
                  }}
                >
                  {serviceMode.value === 1 && <RoadIcon />}
                  {serviceMode.value === 2 && <BusIcon />}
                  {serviceMode.value === 3 && <RailIcon />}
                  {(serviceMode.value === 4 || serviceMode.value === 11) && (
                    <AirIcon />
                  )}
                  {serviceMode.value === 5 && <RoadIcon />}
                  {serviceMode.value === 6 && <RoadIcon />}
                  {serviceMode.value === 7 && <RailIcon />}
                  {serviceMode.value === 8 && <RoadIcon />}
                  {serviceMode.value === 9 && <RoadIcon />}
                  {serviceMode.value === 10 && <RoadIcon />}
                  {serviceMode.value === 12 && <RoadIcon />}
                  {serviceMode.value === 13 && <RoadIcon />}
                  <div
                    className={ClassNames("mt-10 fs-16 fBold tCenter", {
                      // 'theme-color ': rfqDetails.serviceModes.indexOf(serviceMode.value) > -1,
                      // 'label-color ': !(rfqDetails.serviceModes.indexOf(serviceMode.value) > -1)
                      "theme-color ": isSelected(serviceMode),
                      "label-color ": !isSelected(serviceMode),
                    })}
                  >
                    {serviceMode.name}
                  </div>
                </div>
              }
            </Fragment>
          );
        })}
      </FlexWrapperT14>
    </Fragment>
  );
};

export default ServiceModeDetails;
